<template>
<div class="pcoded-inner-content"> 
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
    <div class="row">        
        <div v-if="!formArticle" class="col-lg-12 d-flex align-items-unset mt-4 ml-4">
            <a href="#" class="create" @click="formArticle = true">
                Vytvoriť blog 
            </a>
        </div>
        <div v-if="formArticle" class="col-lg-12">
            <div class="cont">
                <div class="main">
                    <h2 class="nadpis"> {{editableArticel ? 'Uprava' : 'Tvorba'}} článku</h2>
                    <blog-form 
                        :editableArticel="editableArticel"
                        :saved="saved"
                        @cancelForm="cancelForm($event)"
                        @createArticle="createArticle($event)"/>
                </div>
            </div>
        </div>
        <table v-if="articles.length > 0 && !formArticle" class="table">
            <thead>
                <tr>
                <th scope="col" style="padding-left: 20px;">#ID</th>
                <th scope="col">Názov</th>
                <th scope="col" style="width: 30%;">Perex</th>
                <th scope="col">Dátum</th>
                <th scope="col">Akcie</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="article in createdArticles" :key="article.id">
                    <th>{{article.id}}</th>
                    <td>{{article.nazov}}</td>
                    <td style="white-space: normal;">{{article.perex ? (article.perex).substring(0,80) : "NAN"}}</td>
                    <td>{{article.datum}}</td>
                    <td style=" position: relative; display: flex; align-items: center;">
                        <a title="Upraviť" class="my_tooltip m-r-4 " @click="makeEditableArticel(article)">
                            <span class="my_tooltiptext">Upraviť</span>
                            <i class="icon feather icon-edit f-w-600 f-16 text-c-green"></i>
                        </a>
                        <a title="Vymazať" class="my_tooltip m-r-4"  @click="removeArticle(article)">
                            <span class="my_tooltiptext">Vymazať</span>
                            <i class="fa fa-trash f-w-600 f-16 text-danger"></i>
                        </a>
                        <a title="Otvoriť" class="my_tooltip m-r-4"  :href="'/blog/'+article.slug" target="_blank">
                            <span class="my_tooltiptext">Otvoriť</span>
                            <i class="fas fa-external-link-alt  f-w-600 f-16 text-info"></i>
                        </a>
                        <a v-if="!article.active" title="Aktivovať" class="my_tooltip m-r-4" >
                            <span class="my_tooltiptext">Aktivovať</span>
                            <i @click="de_active(1,article.id)" class="fa fa-eye f-w-600 f-16 text-success"></i>
                        </a>
                        <a v-if="article.active" title="Deaktivovať" class="my_tooltip m-r-4" >
                            <span class="my_tooltiptext">Deaktivovať</span>
                            <i @click="de_active(0,article.id)" class="fa fa-eye-slash f-w-600 f-16 text-danger"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import BlogForm from './BlogForm.vue'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
export default {
    components: { BlogForm },
    props: ['articles'],
    data() {
        return {
            formArticle: false,
            editArticle: false,
            editableArticel: null,
            createdArticles: null,
            saved: false,
        }
    },
    created () {
        this.createdArticles = this.articles
    },
    methods: {
        de_active(type,id) {
            if(type == 0){
                var text = "Článok bol deaktivovaný"
            }else{
                var text = "Článok bol aktivovaný"
            }
            this.createdArticles.forEach(r => {
                if(r.id == id){
                    r.active = type
                }
            });
            axios
            .post(`/api/blog/active`, {'id': id,'type':type})
            .then(response => {
                this.$toast.success(text, {
                    position: "top-right",
                    timeout: 3038,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
            })
        },
        removeArticle(article){
            swal.fire({
                title: "Určite?",
                text: "Naozaj chceš vymazať tento článok?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Nie",
                confirmButtonText: "Áno"
            }).then(result => {
                if (result.value) {
                        axios
                        .post(`/api/blog/destroy`, article)
                        .then(response => {
                            this.$toast.success("Článok bol úspešne vymazaný.", {
                                position: "top-right",
                                timeout: 3038,
                                closeOnClick: true,
                                pauseOnFocusLoss: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 0.6,
                                showCloseButtonOnHover: false,
                                hideProgressBar: false,
                                closeButton: "button",
                                icon: true,
                                rtl: false
                            });
                            this.createdArticles = this.createdArticles.filter(function(item) {
                                return item !== article
                            })
                        })
                }
            });
        },
        makeEditableArticel(article){
            this.editableArticel = JSON.parse(JSON.stringify(article));
            this.formArticle = true
            window.scrollTo(0,0);
        },
        createArticle(value){
            let fd = null
            if (typeof value.obrazok === 'string') {
                fd = {
                    existing: "true",
                    file: value.obrazok,
                    id: value.id,
                    nazov: value.nazov,
                    perex: value.perex,
                    slug: value.slug,
                    obsah: value.obsah,
                    datum: value.datum
                }
            } else {
                fd = new FormData();
                fd.append('existing', "false");
                fd.append('id', value.id);
                if(value.obrazok instanceof File) {
                    fd.append('file', value.obrazok);
                }
                fd.append('nazov', value.nazov);
                fd.append('datum', value.datum);
                fd.append('slug', value.slug);
                fd.append('perex', value.perex);
                fd.append('obsah', value.obsah);
            }
            this.saved = true;
            axios
            .post(`/api/blog/create`, fd, {
                headers: {
                    'Content-Type': typeof value.obrazok === 'string' ? 'application/json' : 'multipart/form-data'
                }
            })
            .then(response => {
                this.$toast.success("Článok bol úspešne vytvorený.", {
                    position: "top-right",
                    timeout: 3038,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
                this.cancelForm()
                this.checkArticles(response.data);
                this.saved = false
            })
        },
        checkArticles(article){
            var exist = false;
            for (let i = 0; i < this.createdArticles.length; i++) {
                if(this.createdArticles[i].id == article.id){
                    this.createdArticles[i] = article
                    exist = true
                }
            }
            if(!exist)
                this.createdArticles.push(article)
        },
        cancelForm() {
            this.formArticle = false
            this.editArticle = false
            this.editArticle = null
            this.editableArticel = null
        }
    },
}
</script>

<style lang="scss" scoped>
.card{
    min-height: 150px !important;
}
.create{
    width: 200px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    margin-bottom: 20px;
    background: #2ED8B6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    text-decoration: none;
    &:hover{
        background: #23caa9;
    }
}
.cont{
    width: 1188px;
    margin: 0 auto 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    padding: 40px 0 1px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }            
    .nadpis{
        width: 474px;
        @media only screen and (max-width: 600px) {
            width: 90%;
            text-align: center;
        }
        margin: 0 auto 20px auto;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #000000;
    }
    h1{
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 42px;
        text-align: center;
        color: #2e0808;
    }
    h3{
        width: 740px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 23px auto 36px auto;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        color: #9598A7;
    }
    .main{
        width: 1030px;
        margin: 0 auto;
        background: #F2F7FB;
        border-radius: 5px;
        padding: 30px 0 50px 0;
        margin-bottom: 50px;
        @media only screen and (max-width: 1500px) {
            width: 90%;
        }
        .nadpis{
            width: 474px;
            @media only screen and (max-width: 600px) {
                width: 90%;
                text-align: center;
            }
            margin: 0 auto 20px auto;
            text-align: center;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;
            color: #000000;
        }
        .ulozit{
            width: 474px;
            @media only screen and (max-width: 600px) {
                width: 90%;
            }
            height: 55px;
            margin: 37px auto 75px auto;
            background: #2ED8B6;
            border-radius: 4px;

            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            color: #FFFFFF;
            cursor: pointer;
            transition: .5s all;
            &:hover{
                background: #23caa9;
            }
        }
    }
}
.my_tooltip{
    cursor: pointer;
}
table{
    width: 95%;
    margin: 0 auto;
}
.table > thead > tr{
    border-bottom: 1px solid #dee2e6;
}
.table > thead > tr > th{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    padding: 1.3rem .5rem;
    border-bottom: none;
}
.table > tbody > tr {
    border-top: none;
    border-bottom: 1px solid #dee2e6;
    th{
        padding: 1.3rem .5rem;
        padding-left: 20px;
    }
    td{
        padding: 1.3rem .5rem;
    }
}
</style>